import { CookieCogOutlineIcon } from './CookieCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 96AE483D-C5CD-424A-A553-C9D5399CAD7F
 * name cookie-cog-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-cog-outline.svg
 * tags
 * - Food / Drink 
 * - Settings 
 */
export const BiscuitCogOutlineIcon = CookieCogOutlineIcon;
export default BiscuitCogOutlineIcon